import { CloudInfoService } from "@buf/brevdev_devplane.connectrpc_es/devplaneapi/v1/cloud_info_connect";
import type { CallOptions } from "@connectrpc/connect";
import type { GPUInstanceType } from "types/InstanceTypes";
import { createConnectClient } from "server/connect";
import {
  getAllPublicInstanceTypesFromDevplane,
  mapInstanceTypes,
} from "server/devplaneInstanceTypes";

const cloudInfoClient = createConnectClient(CloudInfoService);

export async function getInstanceTypeForCloudCredential(
  instanceType: string,
  cloudCredentialId: string,
  options?: CallOptions,
): Promise<GPUInstanceType | null> {
  const response = await cloudInfoClient.listInstanceType(
    {
      cloudCredId: cloudCredentialId,
      options: {
        includePrices: true,
        includeUnavailable: true,
        includeCpu: true,
        instanceTypes: [instanceType],
      },
    },
    options,
  );

  return (
    mapInstanceTypes(response.items, [], cloudCredentialId).find(
      (item) => item.type === instanceType,
    ) ?? null
  );
}

export async function getPublicInstanceTypes() {
  const response = await getAllPublicInstanceTypesFromDevplane();
  if (!response.success || !response.data) {
    throw new Error(response.message || "Unable to load public instance types");
  }
  return response.data;
}
